<template>
    <el-dialog @close="close" title="商 品" :visible.sync="centerDialogVisible" width="47%" center>
        <div v-loading="loading" style="padding:20px;">
            <div v-if="centerDialogVisible">
                <div style="margin-bottom: 20px;" v-for="items in dataArr" :key="items.inquiryQuotationId">
                    <div v-if="items.inquiryQuotationStatusMap"
                        style="font-size: 16px;margin-bottom: 5px;display: flex;align-items: center;color: #CA582E;font-weight: bold;">
                        <i style="font-size: 24px;" class="el-icon-star-on"></i> {{
                            items.inquiryQuotationStatusMap.value
                        }}
                    </div>
                    <div
                        style="height: 100px;border-radius: 15px 15px 0 0;border: 2px solid #CB582E;padding: 10px;position: relative;">
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <div style="display: flex;">
                                <img style="width: 80px;height: 80px;margin-right: 20px;"
                                    src="https://img0.baidu.com/it/u=3918752675,1798038530&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1731430800&t=cef30ea146989335b8496e7c2ec2b295" />
                                <div style="line-height: 22px;">
                                    <p
                                        style="font-size: 16px;font-weight: bold;color: #000;display: flex;align-items: center;">
                                        <span style="margin-right: 10px;">{{ items.resourceNameCn }} <span
                                                v-if="items.resourceNameEn">{{ items.resourceNameEn }}</span> </span>
                                        <!-- <el-rate :value="2" disabled text-color="#ff9900">
                                    </el-rate> -->
                                    </p>
                                    <p style="color: #A5ADB7;"> <i class="el-icon-location"></i> {{ items.address }}</p>
                                    <!-- <p style="color: #A5ADB7;">酒店为旅悦集团蔚徕品牌3.0版本旗舰店。 酒店位于北京市通州区运河西大街主干...</p> -->
                                </div>
                            </div>
                            <div
                                style="width:100px;background-color: #F2F4F4;position: absolute;right: 0;top: 0;display: flex;align-items: center;flex-direction: column;justify-content: space-between;border-radius: 0 9px 0 0;overflow: hidden;">
                                <div
                                    style="height: 30px;background-color: #CB582E;width: 100%;display: flex;align-items: center;justify-content: center;color: #fff;">
                                    <p style="font-weight: bold;font-size: 16px;">{{ items.totalPrice.toFixed(0) }}
                                        <span style="font-size: 12px;">¥</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="padding: 10px;border: 2px solid #CB582E;border-top: none;line-height: 24px;display: flex;align-items: center;">
                        <div style="flex: 1;">
                            <p style="font-size: 15px;font-weight: bold;color: #000;">{{ items.productNameCn }}
                                <!-- <span style="cursor: pointer;text-decoration: underline;color: #CB582E;">查看条款</span> -->
                            </p>
                            <p style="color: rgb(21, 89, 105);font-weight: bold;font-size: 13px;">{{
                                items.cancelPolicyAndOption
                            }}
                            </p>
                            <div style="font-size: 13px;display: flex;align-items: center;">
                                <p style="font-size: 13px;margin-right: 5px;">

                                    <span style="font-weight: bold;color: #000;">{{ items.dateRange }}</span>
                                </p>
                                <span style="color: #CA582E;margin-right: 3px;">报价</span>
                                <span style="color: #000;font-size: 14px;font-weight: bold;margin-right: 5px;">{{
                                    items.offerStr
                                }}</span>
                                <span style="color: #000;font-size: 14px;font-weight: bold;margin-right: 5px;">共 <span
                                        style="color: #CA582E;font-size: 15px;">{{ items.totalPrice.toFixed(0)
                                        }}￥</span>
                                </span>
                            </div>
                        </div>
                        <!-- <div style="padding: 0 8px;border-radius: 10px;border: 1px solid #CA582E;"> -->
                        <el-checkbox @change="selectChange(items.stockId)" size="medium"
                            :checked="selectArr.includes(items.stockId)"></el-checkbox>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="pay">创建订单</el-button>
        </span>
    </el-dialog>
</template>

<script>
import OrderApi from "@/components/Api/order";
export default {
    components: {},
    data() {
        return {
            loading: false,
            centerDialogVisible: false,
            dataArr: [],
            selectArr: [],//勾选的数据
            orderChildrenId: null
        }
    },
    computed: {},
    watch: {},
    methods: {
        open(val, orderChildrenId) {
            this.dataArr = val
            this.orderChildrenId = orderChildrenId
            this.centerDialogVisible = true
        },
        //付款
        pay() {
            if (this.selectArr.length === 0) {
                this.$message.warning('请选择要付款的商品')
                return
            }
            let obj = {
                "orderChildrenId": this.orderChildrenId,
                "stockIds": this.selectArr
            }

            new OrderApi('order').createOrderByStockIds(obj).then(res => {
                if (res.status == 200) {
                    this.$message.success('创建成功！')
                    this.$emit('openPay',res.data)
                } else {
                    this.$message({
                        type: 'warning',
                        message: res.statusText
                    });
                }
            })
        },
        close() {
            this.selectArr = []
            this.$emit('updateList')
        },
        selectChange(stockId) {
            if (this.selectArr.includes(stockId)) {
                this.selectArr = this.selectArr.filter(item => item != stockId)
            } else {
                this.selectArr.push(stockId)
            }
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-rate {
    min-height: 0.2rem !important;
}
</style>